import React from 'react';
import { Route, Switch } from 'react-router-dom';
import { LayoutWithLeftSideMenu } from './routes/LayoutWithLeftSideMenu';
import { LayoutWithoutLeftSideMenu } from './routes/LayoutWithoutLeftSideMenu';
import { StartMain } from './routes/StartMain';
import { CreateHearingPage } from './routes/CreateHearingPage';
import {
  ADMIN_HOME_URL,
  ADMIN_SUBJECTAREA_URL,
  ADMIN_GLOBAL_CONTENT_URL,
  ADMIN_HEARINGTYPE_URL,
  ADMIN_FIELDTEMPLATES_URL,
  ADMIN_KLE_URL,
  CREATE_HEARING_URL,
  CURRENT_HEARINGS_URL,
  FINALIZED_HEARINGS_URL,
  HEARING_DETAILS_URL,
  HOME_URL,
  MY_HEARINGS_ANSWERED_URL,
  MY_HEARINGS_REVIEWER_URL,
  MY_HEARINGS_WROTE_URL,
  MY_HEARINGS_INVITED_URL,
  ADMIN_CITYAREA_URL,
  ADMIN_INVITATIONGROUPS_URL,
} from '../../constants/urls';
import { MyHearingsPage } from './routes/MyHearingsPage';
import { CurrentHearingsPage } from './routes/CurrentHearingsPage';
import { ConcludedHearingsPage } from './routes/ConcludedHearingsPage';
import { AdministrationPage } from './routes/AdministrationPage';
import { HearingDetailsPage } from './routes/HearingDetailsPage';
import { SubjectAreaAdministrationPage } from './routes/SubjectAreaAdministrationPage';
import { CityAreaAdministrationPage } from './routes/CityAreaAdministrationPage';
import { GlobalContentAdministrationPage } from './routes/GlobalContentAdministrationPage';
import { HearingTypeAdministrationPage } from './routes/HearingTypeAdministrationPage';
import { KleMappingAdministrationPage } from './routes/KleMappingAdministrationPage';
import { FieldTemplateAdministrationPage } from './routes/FieldTemplateAdministrationPage';
import { InvitationGroupAdministrationPage } from './routes/InvitationGroupAdministrationPage';

const Routes = (props) => {
  return (
    <div>
      <Switch>
        <Route
          exact
          path={HOME_URL}
          render={() => (
            <LayoutWithoutLeftSideMenu {...props}>
              <StartMain />
            </LayoutWithoutLeftSideMenu>
          )}
        />
        <Route
          path={CURRENT_HEARINGS_URL}
          render={() => (
            <LayoutWithLeftSideMenu {...props}>
              <CurrentHearingsPage />
            </LayoutWithLeftSideMenu>
          )}
        />
        <Route
          path={MY_HEARINGS_WROTE_URL}
          render={() => (
            <LayoutWithLeftSideMenu {...props}>
              <MyHearingsPage />
            </LayoutWithLeftSideMenu>
          )}
        />
        <Route
          path={MY_HEARINGS_ANSWERED_URL}
          render={() => (
            <LayoutWithLeftSideMenu {...props}>
              <MyHearingsPage />
            </LayoutWithLeftSideMenu>
          )}
        />
        <Route
          path={MY_HEARINGS_REVIEWER_URL}
          render={() => (
            <LayoutWithLeftSideMenu {...props}>
              <MyHearingsPage />
            </LayoutWithLeftSideMenu>
          )}
        />
        <Route
          path={MY_HEARINGS_INVITED_URL}
          render={() => (
            <LayoutWithLeftSideMenu {...props}>
              <MyHearingsPage />
            </LayoutWithLeftSideMenu>
          )}
        />
        <Route
          path={CREATE_HEARING_URL}
          render={() => (
            <LayoutWithLeftSideMenu {...props}>
              <CreateHearingPage />
            </LayoutWithLeftSideMenu>
          )}
        />
        <Route
          path={FINALIZED_HEARINGS_URL}
          render={() => (
            <LayoutWithLeftSideMenu {...props}>
              <ConcludedHearingsPage />
            </LayoutWithLeftSideMenu>
          )}
        />
        <Route
          path={HEARING_DETAILS_URL}
          render={(routerProps) => (
            <LayoutWithLeftSideMenu {...props}>
              <HearingDetailsPage hearingId={routerProps.match.params.id} />
            </LayoutWithLeftSideMenu>
          )}
        />
        <Route
          path={ADMIN_SUBJECTAREA_URL}
          render={() => (
            <LayoutWithLeftSideMenu {...props}>
              <SubjectAreaAdministrationPage />
            </LayoutWithLeftSideMenu>
          )}
        />
        <Route
          path={ADMIN_CITYAREA_URL}
          render={() => (
            <LayoutWithLeftSideMenu {...props}>
              <CityAreaAdministrationPage />
            </LayoutWithLeftSideMenu>
          )}
        />
        <Route
          path={ADMIN_GLOBAL_CONTENT_URL}
          render={() => (
            <LayoutWithLeftSideMenu {...props}>
              <GlobalContentAdministrationPage />
            </LayoutWithLeftSideMenu>
          )}
        />
        <Route
          path={ADMIN_HEARINGTYPE_URL}
          render={() => (
            <LayoutWithLeftSideMenu {...props}>
              <HearingTypeAdministrationPage />
            </LayoutWithLeftSideMenu>
          )}
        />
        <Route
          path={ADMIN_KLE_URL}
          render={() => (
            <LayoutWithLeftSideMenu {...props}>
              <KleMappingAdministrationPage />
            </LayoutWithLeftSideMenu>
          )}
        />
        <Route
          path={ADMIN_FIELDTEMPLATES_URL}
          render={() => (
            <LayoutWithLeftSideMenu {...props}>
              <FieldTemplateAdministrationPage />
            </LayoutWithLeftSideMenu>
          )}
        />
        <Route
          path={ADMIN_INVITATIONGROUPS_URL}
          render={() => (
            <LayoutWithLeftSideMenu {...props}>
              <InvitationGroupAdministrationPage />
            </LayoutWithLeftSideMenu>
          )}
        />
        <Route
          path={ADMIN_HOME_URL}
          render={() => (
            <LayoutWithLeftSideMenu {...props}>
              <AdministrationPage />
            </LayoutWithLeftSideMenu>
          )}
        />
        <Route
          render={() => (
            <LayoutWithoutLeftSideMenu {...props}>
              <StartMain />
            </LayoutWithoutLeftSideMenu>
          )}
        />
      </Switch>
    </div>
  );
};

export { Routes };
